var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.913 2V9.30435H8.30435V22.6957H1V4.43478C1.00189 3.78962 1.25902 3.17142 1.71522 2.71522C2.17142 2.25902 2.78962 2.00189 3.43478 2H22.913Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.9131 29.9997V22.6953H30.2174L22.9131 29.9997Z",
    fill: "#EA4435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.9131 8.08691H30.2174V22.6956H22.9131V8.08691Z",
    fill: "#FFBA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.9131 22.6953V29.9997H8.30439V22.6953H22.9131Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M30.2174 4.43478V9.30435H22.9131V2H27.7827C28.4278 2.00189 29.046 2.25902 29.5022 2.71522C29.9584 3.17142 30.2155 3.78962 30.2174 4.43478Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.30435 22.6953V29.9997H3.43478C2.78962 29.9978 2.17142 29.7406 1.71522 29.2844C1.25902 28.8282 1.00189 28.21 1 27.5649V22.6953H8.30435Z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M15.2315 17.3274C15.2315 18.4108 14.428 19.5065 12.6141 19.5065C11.9661 19.5151 11.3275 19.3512 10.7637 19.0317L10.6663 18.9587L11.0193 17.9604L11.1776 18.0578C11.6078 18.3183 12.099 18.4611 12.6019 18.4717C12.7967 18.4842 12.992 18.4571 13.1761 18.3923C13.3601 18.3274 13.5292 18.2261 13.6732 18.0943C13.7764 17.991 13.8568 17.8672 13.9092 17.7309C13.9616 17.5946 13.9849 17.4489 13.9776 17.303C13.9654 16.4143 13.1497 16.0978 12.3828 16.0978H11.7254V15.1117H12.3828C12.9306 15.1117 13.7463 14.8439 13.7463 14.1135C13.7463 13.5656 13.3689 13.2491 12.7115 13.2491C12.2578 13.259 11.8173 13.403 11.4454 13.663L11.275 13.7848L10.9341 12.823L11.0193 12.75C11.5749 12.3928 12.2214 12.2027 12.8819 12.2021C14.3306 12.2021 14.9758 13.0908 14.9758 13.9674C14.9774 14.2973 14.8857 14.621 14.7112 14.901C14.5368 15.181 14.2866 15.406 13.9897 15.55C14.3574 15.678 14.6753 15.9186 14.8982 16.2378C15.1211 16.5569 15.2378 16.9381 15.2315 17.3274Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M18.9076 12.3232V19.3963H17.7146V13.565L16.5702 14.1859L16.3146 13.1876L17.9824 12.3232H18.9076Z",
    fill: "#4285F4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendar);
export default __webpack_public_path__ + "static/media/googleCalendar.9355d338c8ae129afa869bf3774e46db.svg";
export { ForwardRef as ReactComponent };